// Libs
import React from 'react';
// Context
import { useComponentsPool } from '../../../ComponentsPool';

export default () => {
    const { Component } = useComponentsPool();
    return <Component componentName={'GroupsTable'} />;
};
